import MainSis from '@/modules/layout/main.vue'
import Login from '@/modules/layout/login/main.vue'
import loadView from './helpers/loadView'
const RecuperarSenha = 'modules/externo/recuperar-senha/main'
const validarDocumento = 'modules/externo/validar-documento/main'
const SuprimentoRecebimento = 'modules/externo/suprimento-recebimento/main'

export default [
	{
		path: '/load',
		component: MainSis,
		name: 'load',
	},
	{
		path: '/login',
		component: Login,
		name: 'login',
		props: true,
	},
	{
		path: '/reseta-senha/:email/:id/:hash/:login',
		name: 'publico',
		component: loadView(RecuperarSenha),
		props: true,
	},
	{
		path: '/valida-documento/:hash?',
		name: 'publico',
		component: loadView(validarDocumento),
		props: true,
	},
	{
		path: '/suprimento-recebimento',
		name: 'suprimento-recebimento',
		component: loadView(SuprimentoRecebimento),
		props: true,
	}
]
